import type { Environment } from '../types/lucid-env';

const environmentOptions = ['development', 'test', 'production', 'preprod', 'staging'];

const isValidEnv = (value?: string): value is Environment => (value ? environmentOptions.includes(value) : false);

const getEnv = (): Environment => {
  const currentEnv = process.env.NODE_ENV;

  if (isValidEnv(currentEnv)) {
    return currentEnv;
  }

  return 'development';
};

export const isDev = () => 'development' === getEnv();
export const isTest = () => 'test' === getEnv();
export const isProd = () => 'production' === getEnv();
export const isPreProd = () => 'preprod' === getEnv();
export const isStaging = () => 'staging' === getEnv();

export default getEnv;
